import { React, useState, useContext, useEffect, useRef } from "react";

import {
  Dialog,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
  Grid,
  Container,
  FormControlLabel,
  Switch,
  Icon,
  makeStyles,
  Tooltip,
} from "@material-ui/core";

//Ícones
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import WorkIcon from "@material-ui/icons/Work";
import PaymentIcon from "@material-ui/icons/Payment";
import MoneyIcon from "@material-ui/icons/Money";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Select from "../../../../components/basics/SelectErp";

import CloseIcon from "@material-ui/icons/Close";

import {
  DataAria,
  MainContent,
  ReceberContainer,
  ModalButtons,
  ModalContent,
  Separator,
  DataTable,
  AvatarCustom,
  CustomItemListText,
} from "../styles/VendaRapida";

import Btn from "../../../../components/buttons/Btn";
import TableDefault from "../../../../components/grid/TableDefault";

import ModalChequeCartao from "./ModalChequeCartao";

import { VendaRapidaContext } from "../contexts/VendaRapidaContext";
import useVendaRapidaController from "../controllers/VendaRapidaController";

import MaskService from "../../../../utils/mask/maskService";

import Loading from "../../../../components/basics/Loading";
import { AccountBalanceWalletOutlined } from "@material-ui/icons";

import ModalAutenticarUsuario from "../../../../components/authenticate/ModalAutenticarUsuario";
import ModalDesconto from "./ModalDesconto";
import ModalVisualizarDesconto from "./ModalVisualizarDeconto";

const useStyles = makeStyles({
  CustomGridAlign: {
    flexDirection: "column",
    alignItems: "center",
  },
  CustomGridItem: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  DisplayFlex: {
    display: "flex",
  },
  MarginBottomButton: {
    marginBottom: "20px",
  },
  CustomGridButtonAdd: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
});

const ModalVRFReceber = ({ modalProdutosOpen, handleProductFocus, index }) => {
  const {
    onTotalDiscount,
    setOnTotalDiscount,
    toPayValue,
    orderTotal,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    selectedPaymentType,
    setSelectedPaymentType,
    isPercentage,
    setIsPercentage,
    setModalFinishOpen,
    paymentValue,
    setPaymentValue,
    totalPayment,
    troco,
    paymentRows,
    paymentErrors,
    modalVrfLoading,
    modalChequeCartaoOpen,
    buttonNewOrderView,
    storedOrderCode,
    displayNoneTransmit,
    setDisplayNoneTransmit,
    finishButtonView,
    disabledPaymentActions,
    paymentMethods,
    paymentTypes,
    totalDiscountView,
    isCheck,
    modalAuthenticateOpen,
    modalAuthenticateWarnings,
    setModalAuthenticateOpen,
    userMaximumDiscountPercentage,
    setUserMaximumDiscountPercentage,
    bankAccountsList,
    selectedBankAccount,
    setSelectedBankAccount,
  } = useContext(VendaRapidaContext);

  const {
    handleOnTotalDiscount,
    handleFinishOrder,
    handleTotalPayment,
    addPaymentRow,
    deletePaymentRow,
    handleCalcPaymentValue,
    resetPage,
    handleActionsAfterFinishOrder,
    editModalChequeCartao,
    finishOrderWithoutRequisitions,
  } = useVendaRapidaController();

  const [modalEmailOpen, setModalEmailOpen] = useState(false);
  const [modalAuthenticateDiscount, setModalAuthenticateDiscount] =
    useState(false);
  const [modalVisualizarOpen, setModalVisualizarOpen] = useState(false);

  const valueInputRef = useRef(null);

  const handleButtonAddClick = () => {
    addPaymentRow();
    handleFocusValueInput();
  };

  useEffect(() => {
    if (bankAccountsList) {
      let selected = bankAccountsList.find(
        (account) => account.st_padrao === true
      );
      setSelectedBankAccount(selected ?? null);
    }
  }, [setSelectedBankAccount, bankAccountsList]);

  useEffect(() => {
    handleOnTotalDiscount();
  }, [handleOnTotalDiscount]);

  useEffect(() => {
    handleTotalPayment();
  }, [handleTotalPayment]);

  useEffect(() => {
    handleCalcPaymentValue();
  }, [paymentRows, handleCalcPaymentValue]);

  useEffect(() => {
    let paymentAmount =
      MaskService.removeMaskDecimal(toPayValue) -
        MaskService.removeMaskDecimal(totalPayment) <
      0
        ? 0.0
        : MaskService.removeMaskDecimal(toPayValue) -
          MaskService.removeMaskDecimal(totalPayment);

    setPaymentValue(MaskService.toMask("decimal", paymentAmount.toFixed(2)));
  }, [toPayValue, totalPayment, setSelectedPaymentType, setPaymentValue]);

  const handleClose = () => {
    setModalFinishOpen(false);
  };

  const toggleChecked = () => {
    setIsPercentage((prev) => !prev);
  };

  const finishOrder = () => {
    handleFinishOrder(false, true, false);
  };

  const finishAndTransmit = () => {
    handleFinishOrder(true, true, true);
  };

  const handleTransmitAfterFinishOrder = () => {
    handleActionsAfterFinishOrder(
      storedOrderCode,
      true,
      false,
      setDisplayNoneTransmit
    );
  };

  const handlePrePrint = () => {
    handleActionsAfterFinishOrder(storedOrderCode, false, true);
  };

  const handleFocusValueInput = () => {
    valueInputRef.current.focus();
  };

  const columnsPaymentMethod = [
    { label: "Numero", id: "numero" },
    { label: "Tipo Pgto", id: "tipopagto" },
    { label: "Forma Pagto", id: "formapagto" },
    {
      label: "Valor",
      id: "valor",
    },
    {
      label: "Ações",
      align: "center",
      format: (value) => {
        let returnEditIcon =
          value.idtipopagto === 47 || // cartao credito
          value.idtipopagto === 48 || // cartao debito
          value.idtipopagto === 49; // cheque

        return (
          <>
            {returnEditIcon && (
              <IconButton
                onClick={() => editModalChequeCartao(value.idtipopagto, value)}
                disabled={disabledPaymentActions}
              >
                <Icon>edit</Icon>
              </IconButton>
            )}
            <IconButton
              onClick={() => {
                deletePaymentRow(
                  value.index,
                  value.valor,
                  handleFocusValueInput
                );
              }}
              disabled={disabledPaymentActions}
            >
              <Icon>delete</Icon>
            </IconButton>
          </>
        );
      },
    },
  ];

  const classes = useStyles();

  const {
    CustomGridItem,
    DisplayFlex,
    MarginBottomButton,
    CustomGridButtonAdd,
    CustomGridAlign,
  } = classes;

  return (
    <>
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        disableEnforceFocus
      >
        <AppBar>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Grid item lg={12}>
              <Typography variant="h6">FINALIZAÇÃO DO PEDIDO</Typography>
            </Grid>
          </Toolbar>
        </AppBar>
        <ModalContent>
          <ReceberContainer>
            <Loading open={modalVrfLoading} />
            {modalAuthenticateOpen && (
              <ModalAutenticarUsuario
                modalAuthenticateOpen={modalAuthenticateOpen}
                setModalAuthenticateOpen={setModalAuthenticateOpen}
                warnings={modalAuthenticateWarnings}
                callback={finishOrderWithoutRequisitions}
              />
            )}
            {modalAuthenticateDiscount && (
              <ModalDesconto
                setOpen={setModalAuthenticateDiscount}
                open={modalAuthenticateDiscount}
                callback={setUserMaximumDiscountPercentage}
              />
            )}
            {modalChequeCartaoOpen && (
              <ModalChequeCartao
                setModalEmailOpen={setModalEmailOpen}
                modalEmailOpen={modalEmailOpen}
                isCheck={isCheck}
              />
            )}
            {modalVisualizarOpen && (
              <ModalVisualizarDesconto
                modalOpen={modalVisualizarOpen}
                setModalOpen={setModalVisualizarOpen}
              />
            )}
            <Container maxWidth="lg">
              <MainContent>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Card className={MarginBottomButton}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} lg={6}>
                          <TextField
                            label={`Desconto Adicional no Total${
                              isPercentage ? " (%)" : ""
                            }`}
                            size="small"
                            disabled={paymentRows.length}
                            value={onTotalDiscount || "0,00"}
                            setValue={setOnTotalDiscount}
                            mask="decimal"
                            maxLength={isPercentage ? "6" : undefined}
                          />
                        </Grid>
                        <Grid item className={DisplayFlex} sm={4} md={3} lg={3}>
                          <FormControlLabel
                            control={
                              <Switch
                                readOnly
                                color="primary"
                                checked={isPercentage}
                                disabled={paymentRows.length}
                                onChange={toggleChecked}
                              />
                            }
                            label="Percentual"
                          />
                        </Grid>
                        <Grid item className={CustomGridItem} lg={3}>
                          <Tooltip title="Abrir autenticação de usuário">
                            <Btn
                              disabled={
                                paymentRows.length ||
                                userMaximumDiscountPercentage === "100,00"
                              }
                              bgcolor="blue"
                              hovercolor="primary"
                              label={<Icon>lock</Icon>}
                              onClick={() => setModalAuthenticateDiscount(true)}
                            />
                          </Tooltip>
                          <Tooltip title="Visualizar porcentagem de desconto permitida">
                            <Btn
                              bgcolor="blue"
                              hovercolor="primary"
                              label={<Icon>visibility</Icon>}
                              onClick={() => setModalVisualizarOpen(true)}
                            />
                          </Tooltip>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={6}>
                          <TextField
                            label="Valor"
                            size="small"
                            value={paymentValue}
                            setValue={setPaymentValue}
                            mask="decimal"
                            inputRef={valueInputRef}
                            autoFocus
                            error={!!paymentErrors.paymentValue}
                            helperText={paymentErrors.paymentValue || ""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={6}>
                          <Select
                            label="Tipo de Pagamento"
                            optionsList={paymentTypes}
                            value={selectedPaymentType}
                            setValue={setSelectedPaymentType}
                            error={
                              paymentErrors.selectedPaymentType ? true : false
                            }
                            helperText={paymentErrors.selectedPaymentType || ""}
                            descriptionField="descricao"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} lg={4}>
                          <Select
                            label="Forma de Pagamento"
                            optionsList={paymentMethods}
                            value={selectedPaymentMethod}
                            setValue={setSelectedPaymentMethod}
                            error={
                              paymentErrors.selectedPaymentMethod ? true : false
                            }
                            helperText={
                              paymentErrors.selectedPaymentMethod || ""
                            }
                            descriptionField="descricao"
                          />
                        </Grid>
                        {selectedPaymentType?.carteira === "N" && (
                          <Grid item xs={12} sm={4} lg={4}>
                            <Select
                              label="Conta Bancária"
                              optionsList={bankAccountsList}
                              value={selectedBankAccount}
                              setValue={setSelectedBankAccount}
                              descriptionField="apelido"
                            />
                          </Grid>
                        )}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={4}
                          className={CustomGridButtonAdd}
                        >
                          <Btn
                            label="Adicionar"
                            bgcolor="blue"
                            hovercolor="primary"
                            onClick={handleButtonAddClick}
                            startIcon={<Icon>add</Icon>}
                            disabled={disabledPaymentActions}
                          />
                        </Grid>
                        <Separator />
                      </Grid>
                    </Card>
                    <DataTable>
                      <Card>
                        <TableDefault
                          tableTitle=""
                          columns={columnsPaymentMethod}
                          values={paymentRows}
                          maxHeight="30vh"
                          disabledTab
                          stickyHeader
                        />
                      </Card>
                    </DataTable>
                  </Grid>
                  <Grid
                    container
                    className={CustomGridAlign}
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    xl={4}
                  >
                    <DataAria>
                      <Card line="left" lineColor="primary" fullHeight>
                        <List>
                          <ListItem>
                            <ListItemAvatar>
                              <AvatarCustom className="Blue">
                                <PaymentIcon />
                              </AvatarCustom>
                            </ListItemAvatar>
                            <CustomItemListText
                              primary="Total do Pedido"
                              secondary={`R$ ${MaskService.toMask(
                                "decimal",
                                orderTotal
                              )}`}
                              className="blueText"
                            />
                          </ListItem>
                          <Separator />
                          <ListItem>
                            <ListItemAvatar>
                              <AvatarCustom>
                                <AccountBalanceWalletOutlined />
                              </AvatarCustom>
                            </ListItemAvatar>
                            <CustomItemListText
                              primary="Desconto no Total"
                              secondary={`R$ ${MaskService.toMask(
                                "decimal",
                                totalDiscountView
                              )}`}
                              className="primaryText"
                            />
                          </ListItem>
                          <Separator />
                          <ListItem>
                            <ListItemAvatar>
                              <AvatarCustom className="Orange">
                                <MonetizationOnIcon />
                              </AvatarCustom>
                            </ListItemAvatar>
                            <CustomItemListText
                              primary="Valor a Pagar"
                              secondary={`R$ ${MaskService.toMask(
                                "decimal",
                                toPayValue
                              )}`}
                              className="orangeText"
                            />
                          </ListItem>
                          <Separator />
                          <ListItem>
                            <ListItemAvatar>
                              <AvatarCustom className="Green">
                                <WorkIcon />
                              </AvatarCustom>
                            </ListItemAvatar>
                            <CustomItemListText
                              primary="Total de Pagamentos"
                              secondary={`R$ ${MaskService.toMask(
                                "decimal",
                                totalPayment
                              )}`}
                              className="greenSecondaryText"
                            />
                          </ListItem>
                          <Separator />
                          <ListItem>
                            <ListItemAvatar>
                              <AvatarCustom className="Red">
                                <MoneyIcon />
                              </AvatarCustom>
                            </ListItemAvatar>
                            <CustomItemListText
                              primary="Troco"
                              secondary={`R$ ${MaskService.toMask(
                                "decimal",
                                troco
                              )}`}
                              className="redSecondaryText"
                            />
                          </ListItem>
                          <Separator />
                          {/* <ListItem>
                            <ListItemAvatar>
                              <AvatarCustom>
                                <AttachMoneyIcon />
                              </AvatarCustom>
                            </ListItemAvatar>
                            <CustomItemListText
                              primary="Comissão Do Vendedor"
                              secondary={`R$ ${MaskService.toMask(
                                "decimal",
                                (
                                  (parseFloat(sellerComission) / 100) *
                                  MaskService.removeMaskDecimal(toPayValue)
                                ).toFixed(2)
                              )}`}
                            />
                          </ListItem> */}
                        </List>
                      </Card>
                    </DataAria>
                    <ModalButtons>
                      <Grid container spacing={2}>
                        {finishButtonView && (
                          <Grid item xs={12} sm={4} md={12} lg={12}>
                            <Btn
                              label="Finalizar Pedido"
                              bgcolor="primary"
                              hovercolor="orange"
                              full="true"
                              onClick={finishOrder}
                            />
                          </Grid>
                        )}
                        {buttonNewOrderView && (
                          <Grid item xs={12} sm={4} md={12} lg={12}>
                            <Btn
                              label="pré impressão"
                              bgcolor="tertiary"
                              hovercolor="blue"
                              full="true"
                              onClick={handlePrePrint}
                              displayNone={displayNoneTransmit}
                            />
                          </Grid>
                        )}
                        {storedOrderCode ? (
                          <Grid item xs={12} sm={4} md={12} lg={12}>
                            <Btn
                              displayNone={displayNoneTransmit}
                              label="Transmitir"
                              bgcolor="primary"
                              hovercolor="orange"
                              full="true"
                              onClick={handleTransmitAfterFinishOrder}
                            />
                          </Grid>
                        ) : (
                          <Grid item xs={12} sm={4} md={12} lg={12}>
                            <Btn
                              label="FINALIZAR E TRANSMITIR"
                              bgcolor="primary"
                              hovercolor="orange"
                              full="true"
                              onClick={finishAndTransmit}
                            />
                          </Grid>
                        )}
                        {buttonNewOrderView && (
                          <Grid item xs={12} sm={4} md={12} lg={12}>
                            <Btn
                              label="Novo pedido"
                              bgcolor="green"
                              hovercolor="green"
                              full="true"
                              onClick={() => resetPage(handleProductFocus)}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </ModalButtons>
                  </Grid>
                </Grid>
              </MainContent>
            </Container>
          </ReceberContainer>
        </ModalContent>
      </Dialog>
    </>
  );
};

export default ModalVRFReceber;
